<div class="form-group">
  <cpq-input [label]="{placeholder: labelAvailable.placeholder}" #searchAvailableItems="ngModel" [name]="'searchAvailableItems'"
  [(ngModel)]='searchKeyword' (ngModelChange)="search()"></cpq-input>
  <span [ngClass]="{'sap-icon': true, 'search-icon': !searchKeyword, 'close-icon': searchKeyword}" (click)="clearSearchInput()"></span>
  @if (!hasSearchResults) {
    <ul class="no-results">
      <li>
        {{'Admin.Msg.NoResultsSearch' | translate}}
      </li>
    </ul>
  }
</div>

<div class="flex-between">
  @if (labelLink) {
    <span class="text-left">
      <a [class.cpq-disabled]='isReadOnly' (click)="!isReadOnly && onLinkClick($event)">
        {{labelLink.key | translate}}
      </a>
    </span>
  }
  <div class="select-checkbox-wrapper">
    <span class="select-all-cb-container" (click)="$event.stopPropagation()">
      <mat-checkbox #allGroupsCheckbox [disabled]="isReadOnly || !groups"  [checked]="allGroupsCheckboxState === MultiListBoxItemState.All" [indeterminate]="allGroupsCheckboxState === MultiListBoxItemState.Indeterminate" (click)="toggleSelectAllCb(allGroupsCheckbox.checked, $event)"></mat-checkbox>
    </span>
    <span class='show-only-selected'>
      <mat-checkbox [(ngModel)]="showOnlySelected" [disabled]='isShowOnlySelectedDisabled' >{{'Msg.ShowOnlySelected' | translate}}</mat-checkbox>
    </span>
  </div>
</div>
<ul class="main-list cpq-scroll">
  <!-- available items  -->
  @for (item of groups; track item) {
    @if (item && item.isVisible) {
      <li>
        <div class="text-container" (click)="colapse(item)">
          <span [ngClass]="{'rotate': !item.isCollapsed}" class="available-list-item-wrapper">
            <span>
              <span class="select-all-cb-container" (click)="$event.stopPropagation()">
                <mat-checkbox [ngClass]="{'checkbox-disabled':item.isDisabled || !item.children}" [disabled]="isReadOnly || item.isDisabled || !item.children" [checked]="item.selectedAllChildrenState === MultiListBoxItemState.All" [indeterminate]="item.selectedAllChildrenState == MultiListBoxItemState.Indeterminate" (click)="!isReadOnly && toggleGroupSelectAllCb(item, $event)"></mat-checkbox>
              </span>
              <span [ngClass]="{'hide-dropdown-icon':item.isDisabled || !item.children, 'sap-icon dropdown-icon':!item.isDisabled && item.children}">&#xe066;</span>
              <span class="main-item" [class.has-toggle]="item.hasCustomTemplate" [title]='item.name'>{{ item.name }}</span>
            </span>
            @if (item.hasCustomTemplate) {
              <div class="text-right">
                <ng-container *ngTemplateOutlet="groupCustomTemplate; context:{ item: item }" ></ng-container>
              </div>
            }
          </span>
        </div>
        @if (item.children) {
          <ul class="items-container cpq-scroll">
            @for (child of item.children; track child) {
              @if (allItems.indexOf(child) !== -1) {
                <li #listItem [class.selected]="child.isSelected" [hidden]="!child.isVisible" [ngClass]="{'expanded' : !item.isCollapsed, 'invisible': !child.isVisible, 'cpq-disabled': isReadOnly }"
                  class="child-item">
                  <div class="text-container row-container" [ngClass]="{'selected': child.isSelected, 'cpq-disabled': isReadOnly}" (click)="!isReadOnly && toggleSelectedChildren(child, $event)" id="{{item.name}}_{{child.name}}">
                    <div class="cb-label-container">
                      <div [class.checked]="child.isSelected" class="check-icon-container">
                        <span class="sap-icon"></span>
                      </div>
                      <span [class.has-toggle]="childCustomTemplate && shouldRenderCustomTemplate(child)" [title]='child.name' class="child-name">{{ child.name }}</span>
                      @if (child.additionalInfo && child.additionalInfo.length > 0) {
                        <div>
                          <span>&nbsp;{{ child.additionalInfo }}</span>
                        </div>
                      }
                    </div>
                    @if (childCustomTemplate && shouldRenderCustomTemplate(child)) {
                      <div class="text-right">
                        <ng-container *ngTemplateOutlet="childCustomTemplate; context: { item : child }"></ng-container>
                      </div>
                    }
                  </div>
                </li>
              }
            }
          </ul>
        }
      </li>
    }
  }
</ul>
